import { Col } from 'react-bootstrap'
import Chart from 'react-apexcharts'
import Card from '../common/Card'

const PUBLISHERS = {
    audience_network: 'Audience Network',
    facebook: 'Facebook',
    instagram: 'Instagram',
    unknown: 'Unknown'
}

const PublisherPlatformChart = ({ name, data }) => {
    const publishers = typeof data.publishers === 'string' ? JSON.parse(data.publishers) : data.publishers
    const keys = !publishers
        ? ['audience_network', 'facebook', 'instagram']
        : (Object.keys(publishers).length > 0 ?Object.keys(publishers) : ['audience_network', 'facebook', 'instagram'])

    const options = {
        theme: {
            monochrome: {
                enabled: true,
                color: '#427EEB',
                shadeTo: 'light'
            }
        },
        legend: {
            position: 'bottom'
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 250
                },
                legend: {
                    position: 'bottom'
                }
            }
        }],
        dataLabels: {
            style: {
                fontSize: '16px'
            }
        }
    }
    const labels = keys.map((key) => PUBLISHERS[key])
    const series = publishers && Object.keys(publishers).length > 0 ? Object.values(publishers) : [0, 0, 0]

    options['labels'] = labels

    return (
        <Col md={12} xl={4}>
            <Card data-aos="fade-up" data-aos-delay="1000">
                <div className="flex-wrap card-header d-flex justify-content-between">
                    <div className="header-title">
                        <h4 className="card-title">{name}</h4>
                    </div>
                </div>
                <Card.Body>
                    <Chart className="d-activity" options={options} series={series} type="pie" height="330" />
                </Card.Body>
            </Card>
        </Col>
    )
}

export default PublisherPlatformChart